module.exports = __webpack_public_path__ + "img/第5章_3-1_水牢畫圖.jpg";